module.exports = __webpack_public_path__ + "img/star1.1c4bc622.png";